import {
  Box,
  Button,
  FormField,
  SpaceBetween,
} from "@amzn/awsui-components-react/polaris";
import { get, useForm } from "react-hook-form";
import {
  ControlledInput,
  ControlledDatePicker,
  ControlledSelect,
} from "@amzn/react-hook-form-polaris";
import { zodResolver } from "@hookform/resolvers/zod";
import globals from "app/style.module.scss";
import styles from "app/style.module.scss";
import { ICreateTaskGroupFormProps } from "./definitions";
import {
  createTaskGroupSchema,
  CreateTaskGroupFormFields,
} from "models/schemas";
import { useEffect } from "react";
import { useGaiaObjectUiContent } from "features/ui-content";

export const CreateTaskGroupForm: React.FC<ICreateTaskGroupFormProps> = (
  props: ICreateTaskGroupFormProps,
) => {
  const {
    control,
    handleSubmit,
    formState: { errors, isValid },
    reset,
    watch,
  } = useForm<CreateTaskGroupFormFields>({
    mode: "onBlur",
    resolver: zodResolver(createTaskGroupSchema),
  });
  const uiContent: any = useGaiaObjectUiContent(props.parentCategory);
  const taskGroupName = watch("taskName");

  useEffect(() => {
    reset();
  }, [props.resetForm, reset]);

  return (
    <form
      role="form"
      onSubmit={handleSubmit((values) => {
        props.onCreate(values);
        reset();
      })}
    >
      <SpaceBetween direction="vertical" size="l">
        <FormField
          label="Name"
          className={styles.modalContent}
          errorText={
            (taskGroupName &&
              taskGroupName.length > 128 &&
              "Name exceeded character limit.") ||
            get(errors, "taskName.message")
          }
          constraintText={
            taskGroupName && (
              <div>Character count: {taskGroupName.length}/128</div>
            )
          }
        >
          <ControlledInput
            name="taskName"
            control={control}
            placeholder="Name of the group - ie: Audit Initiation"
          />
        </FormField>
        <FormField
          label={
            <Box fontWeight="bold">
              Type - <i>optional</i>
            </Box>
          }
        >
          <ControlledSelect
            name="taskGroupType"
            control={control}
            options={uiContent.taskGroupTypeOptions}
            placeholder="Choose an option"
            filteringType="auto"
          />
        </FormField>
        <FormField
          label={
            <Box fontWeight="bold">
              Planned start - <i>optional</i>
            </Box>
          }
          errorText={get(errors, "plannedStartDateString.message")}
        >
          <ControlledDatePicker
            name="plannedStartDateString"
            control={control}
            placeholder="YYYY/MM/DD"
            className={globals.dateCustomPicker}
          />
        </FormField>
        <FormField
          label={
            <Box fontWeight="bold">
              Actual start - <i>optional</i>
            </Box>
          }
          errorText={get(errors, "actualStartDateString.message")}
        >
          <ControlledDatePicker
            name="actualStartDateString"
            control={control}
            placeholder="YYYY/MM/DD"
            className={globals.dateCustomPicker}
          />
        </FormField>
        <FormField
          label={
            <Box fontWeight="bold">
              Due date - <i>optional</i>
            </Box>
          }
          errorText={get(errors, "dueDateString.message")}
        >
          <ControlledDatePicker
            name="dueDateString"
            control={control}
            placeholder="YYYY/MM/DD"
            className={globals.dateCustomPicker}
          />
        </FormField>
        <FormField
          label={
            <Box fontWeight="bold">
              Completion date - <i>optional</i>
            </Box>
          }
          errorText={get(errors, "actualCompletionDateString.message")}
        >
          <ControlledDatePicker
            name="actualCompletionDateString"
            control={control}
            placeholder="YYYY/MM/DD"
            className={globals.dateCustomPicker}
          />
        </FormField>
      </SpaceBetween>
      <Box className={styles.modalFooter}>
        <Button
          formAction="none"
          onClick={() => {
            reset();
            props.setVisible(false);
          }}
          variant="link"
        >
          Cancel
        </Button>
        <Button variant="primary" formAction="submit">
          Add
        </Button>
      </Box>
    </form>
  );
};
